export function isDefined(value) {
    return !(value === null || value === undefined);
}
//# sourceMappingURL=lang-utils.js.map